import React from 'react';
import { common, query } from '@kurtosys/ksys-app-template';
import { IAppContext } from '@kurtosys/types/helpers/AnalyticsHelper/IAppContext.js';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { IMouseEvent } from '../../../models/IMouseEvent.js';
import { AnalyticsContext, ComponentBase, InjectedStyledComponent } from '../../../shared/index.js';
import Button from '../Button/Button.js';

import { IRedirectButtonConfiguration, IRedirectButtonProps, IRedirectButtonState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { REDIRECT_BUTTON_CATEGORY_KEY, REDIRECT_BUTTON_COMPONENT_KEY } from './RedirectButton.meta.js';

export class RedirectButton extends ComponentBase<
	IRedirectButtonProps,
	IRedirectButtonState,
	IRedirectButtonConfiguration
> {
	categoryKey = REDIRECT_BUTTON_CATEGORY_KEY;
	componentKey = REDIRECT_BUTTON_COMPONENT_KEY;
	analyticsHelper: common.helpers.AnalyticsHelper<IAppContext> | undefined;

	constructor(props: IRedirectButtonProps) {
		super(props);

		makeObservable(this, {
			buttonClick: computed,
		});
	}
	get buttonClick(): <T = any>(event: IMouseEvent, payload?: T) => void {
		const { redirect, analyticsContext } = this.props;
		const analyticsHelper = this.analyticsHelper;
		const onClick = (event: any, payload: any) => {
			if (redirect) {
				const { defaultUrl, base } = redirect;
				const redirectHelper = new common.helpers.RedirectHelper(
					{ queryClass: query.Query, transformClass: query.transform.Transform },
					defaultUrl,
					base,
				);
				const url = redirectHelper.getRedirectPath(redirect, payload);
				if (analyticsHelper) {
					let redirectDefaultContext = {
						redirectTo: url,
					};
					if (analyticsContext) {
						redirectDefaultContext = {
							redirectTo: url,
							...analyticsContext,
						};
					}
					analyticsHelper.logEvent({
						event: 'button_click',
						eventType: 'click',
						context: {
							...redirectDefaultContext,
						},
					});
				}
				redirectHelper.go(redirect, payload);
			}
		};
		return onClick;
	}
	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { className, redirect, onClick, analyticsContext, ...buttonProps } = this.props;
		return (
			<AnalyticsContext.Consumer>
				{(analyticsHelper) => {
					this.analyticsHelper = analyticsHelper;
					// We manage analytics here, so we suppress them on the Button object
					return (
						<Wrapper className={className}>
							<Button {...buttonProps} suppressAnalytics={true} onClick={this.buttonClick} />
						</Wrapper>
					);
				}}
			</AnalyticsContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(
	observer(RedirectButton),
	REDIRECT_BUTTON_CATEGORY_KEY,
	REDIRECT_BUTTON_COMPONENT_KEY,
);
